export default "__VITE_ASSET__d1f7ed72__"